module.exports = __webpack_public_path__ + "img/glb.c8bb589c.svg";